export const hasPassedElement = (element) => {

	const elementBoundingClientRect = element.getBoundingClientRect();
	const elementTop = elementBoundingClientRect.top;
	const elementBottom = elementTop + elementBoundingClientRect.height;

	return elementBottom < 0;
};
